import { BaseDto } from "@/shared/dtos/base-dto";

export class empresa extends BaseDto {
  public nombre!: string;
}
